module.exports = __webpack_public_path__ + "static/img/major_pictgrid21_920x918.89557c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_pictgrid21_920x918.jpg
// module id = R9aA
// module chunks = 0